import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  header: {
    id: 'cookie-banner.header',
    defaultMessage: 'This site uses cookies and similar technologies',
  },
  body: {
    id: 'cookie-banner.body',
    defaultMessage:
      'This site uses cookies and similar tools, some of which are provided by third parties, to operate and improve our site, enable social media and other features, and support our advertising and marketing efforts, as well as to collect user data and browsing information and record user sessions and interactions with this site. We and these third parties use the information collected to analyze and improve performance, understand more about users and their interactions with our site and third-party sites and services, provide personalized experiences, and reach users with more relevant content and ads on this site and across third-party sites. You can review and change your preferences for certain cookies on our site, including opting out, by clicking “Cookie Preferences”. More info: <privacy-policy-link>Privacy Policy.</privacy-policy-link>',
  },
  bodyEU: {
    id: 'cookie-banner.bodyEU',
    defaultMessage:
      'Cookies and similar technologies are important to the proper functioning of a site. Click "Accept" to allow us to use cookies and similar technologies to offer you a better browsing experience, analyze site traffic, personalize content, record user sessions, and serve targeted advertisements. Click “Reject” if you do not want us to use cookies and similar technologies for these purposes. Click "Cookie Settings" to see detailed descriptions of the types of cookies and similar technologies, and choose whether to accept certain cookies while on the site. Find out more by clicking on the “Cookie Settings” button below.',
  },
  ok: {
    id: 'cookie-banner.other.accept',
    defaultMessage: 'OK',
  },
  accept: {
    id: 'cookie-banner.eu.accept',
    defaultMessage: 'Accept',
  },
  reject: {
    id: 'cookie-banner.eu.reject',
    defaultMessage: 'Reject',
  },
  cookiePreferences: {
    id: 'cookie-banner.ca.cookiePreferences',
    defaultMessage: 'Cookie Preferences',
  },
  cookieSettings: {
    id: 'cookie-banner.eu.cookieSettings',
    defaultMessage: 'Cookie Settings',
  },
});
